import calculatorInitiated from './transforms/calculatorInitiated';
import calculatorSubmitted from './transforms/calculatorSubmitted';
import carCompareClick from './transforms/carCompareClick';
import chatSubmission from './transforms/chatSubmission';
import financeLeadInitiation from './transforms/financeLeadInitiation';
import notifyMeInitiated from './transforms/notifyMeInitiated';
import notifyMeSubmitted from './transforms/notifyMeSubmitted';
import pageLoad from './transforms/pageLoad';
import pageState from './transforms/pageState';
import photoInteraction from './transforms/photoInteraction';
import quickLinkClick from './transforms/quickLinkClick';
import recommendedCarClick from './transforms/recommendedCarClick';
import recommendedCarImpression from './transforms/recommendedCarImpression';
import reservationAndInstantOfferStatus from './transforms/reservationAndInstantOfferStatus';
import saveCar from './transforms/saveCar';
import saveSearch from './transforms/saveSearch';
import saveSearchSubmit from './transforms/saveSearchSubmit';
import searchResultTileClick from './transforms/searchResultTileClick';
import sortClick from './transforms/sortClick';
import userLocationChangeInit from './transforms/userLocationChangeInit';
import userLocationChangeSubmit from './transforms/userLocationChangeSubmit';
import type { ClickEventMap, IClickInputOverrides } from './types/registry';

type TransformFn<K extends keyof IClickInputOverrides> = (
  input: IClickInputOverrides[K],
) => Omit<ClickEventMap[K], 'event'>;

/**
 * Register transform functions for events whose consumer input
 * differs from the wire payload.
 */
export const clickTransforms: {
  [K in keyof IClickInputOverrides]: TransformFn<K>;
} = {
  calculatorInitiated,
  calculatorSubmitted,
  financeLeadInitiation,
  quickLinkClick,
  recommendedCarClick,
  saveCar,
  saveSearch,
  carCompareClick,
  sortClick,
  notifyMeInitiated,
  notifyMeSubmitted,
  userLocationChangeSubmit,
  photoInteraction,
  searchResultTileClick,
  saveSearchSubmit,
  userLocationChangeInit,
  chatSubmission,
  reservationAndInstantOfferStatus,
};

export const impressionTransforms = {
  recommendedCarImpression,
  pageState,
};

export const pageLoadTransforms = {
  pageLoad,
};
